import { getDaysInMonth } from 'date-fns';
import { BillingPeriod } from 'src/pages/billing/billing.types';

import { getMonthName } from './getMonthName';

export const FIRST_HALF_LAST_DAY = 15;

/**
 * "September 2026" for a whole-month invoice, "September 1-15, 2026" / "September 16-30, 2026" for a half.
 */
export const getPeriodLabel = (month: number, year: number, period?: BillingPeriod) => {
  const monthName = getMonthName(month);
  if (period === 'FirstHalf') {
    return `${monthName} 1-${FIRST_HALF_LAST_DAY}, ${year}`;
  }
  if (period === 'SecondHalf') {
    const lastDay = getDaysInMonth(new Date(year, month - 1));
    return `${monthName} ${FIRST_HALF_LAST_DAY + 1}-${lastDay}, ${year}`;
  }
  return `${monthName} ${year}`;
};

export const isHalfMonth = (period?: BillingPeriod) =>
  period === 'FirstHalf' || period === 'SecondHalf';
